function prependRootToPath(path, root) {
	return ((!path.indexOf('/') ? '/' : '') + root + "/" + path).replace(/\/+/g, "/");
}

function prependRoot(item, root) {
	if (typeof item === 'string')
		return prependRootToPath(item, root);
	throw new Error("Unrecognised item");
}

export {prependRoot, prependRootToPath};
